/**
 * @author Ivan Toth.
 */
var bfBind = { comp: '=', diff: '=', diffArray: '=' };
var DetailBrandFamilyController = (function () {
    function DetailBrandFamilyController(topic, settings, $scope, env, Dialog, notify) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this.$scope = $scope;
        this.env = env;
        this.Dialog = Dialog;
        this.notify = notify;
        this.editableSolution = false;
        this.editableDuplicate = false;
        this.isSolutionUpdating = false;
        this.isDupeUpdating = false;
        this.completeSection = 'bfCheck';
        this.visible = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            _this.isSolutionUpdating = false;
            _this.isDupeUpdating = false;
            _this.topic.setTempFromTopic();
            var newGoe = (_this.topic.topic.goe && _this.topic.topic.goe.picked)
                ? _this.topic.topic.goe.picked : '';
            if (_this.usedGoe !== newGoe) {
                _this.usedGoe = newGoe;
                // this.setEligOptions();
                _this.setDuplicateCheckOptions();
            }
            _this.setEligOptions();
            // Need to disable the Solution ID editing if not in Elig...currently if status is
            // changed to Rejected/Marked... the editcomponents coming back from server may not be set
            if (_this.comp === 'gpp' && !_this.topic.isInEligibilityStatus()) {
                _this.topic.editableComponents.gpp = { editable: false, editMode: false, socket: 'Not Editable' };
            }
        });
    }
    DetailBrandFamilyController.prototype.$onInit = function () {
        if (this.comp === 'gpp') {
            this.topic.setTempFromTopic([this.comp], false);
        }
        this.usedGoe = (this.topic.topic.goe && this.topic.topic.goe.picked)
            ? this.topic.topic.goe.picked : '';
        this.setEligOptions();
        this.setDuplicateCheckOptions();
    };
    /**
     * Function for when someone edits a Brand Family's Solutions IDs
     * @param event
     * @param action
     * @param line
     */
    DetailBrandFamilyController.prototype.editSolution = function (event, action, line) {
        var _this = this;
        var ids = [];
        if (angular.isDefined(line.solutionId) && line.solutionId !== '') {
            ids = line.solutionId.split('\n');
        }
        var sols = [];
        angular.forEach(ids, function (solly) {
            sols.push({ o: solly, n: angular.copy(solly), d: false });
        });
        var items = {
            count: ids.length,
            ecount: ids.length,
            edit: sols,
            mysaSols: line.solutionId_mysa ? line.solutionId_mysa.split('\n') : [],
            solDec: this.topic.topic.solutionDecision,
            update: function (t, solly, index) {
                if (t === 'Add') {
                    this.edit.push({ o: '', n: '', d: false, x: true });
                    this.ecount++;
                }
                else if (t === 'Delete') {
                    if (solly.x) {
                        this.edit.splice(index, 1);
                    }
                    else {
                        solly.d = true;
                        solly.n = 'Marked for Deletion';
                    }
                    this.ecount--;
                }
                else {
                    if (solly.d) {
                        this.ecount++;
                        solly.d = false;
                    }
                    solly.n = solly.o;
                }
            }
        };
        this.Dialog.updateValidForm(event, items, 'detail-general-solution-update-dialog.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                var changed = false; // Flag to indicate if there is actually a change
                var dupes = 0; // number of dupes in the list
                var newSolutions = []; // array of solutions
                var userSolutions = []; // array of original solutions altered or deleted
                var comments = '';
                // Loop through the solutions
                for (var _i = 0, _a = dResult.edit; _i < _a.length; _i++) {
                    var solution = _a[_i];
                    // If changed...
                    if (solution.o !== solution.n) {
                        changed = true;
                        // Build comments for history
                        if (comments.length > 0) {
                            comments += '; ';
                        }
                        if (solution.d) {
                            comments += "'" + solution.o + "' deleted";
                        }
                        else if (solution.x) {
                            comments += "'" + solution.n + "' added";
                        }
                        else {
                            comments += "'" + solution.o + "' changed to '" + solution.n + "'";
                        }
                        // If not deleted...
                        if (!solution.d) {
                            if (newSolutions.indexOf(solution.n) < 0) {
                                newSolutions.push(solution.n); // build new topic.temp value
                            }
                            else {
                                dupes++;
                            }
                            userSolutions.push(solution.o); // Add new or edited entry to user-edtied list
                        }
                        else {
                            userSolutions.push(solution.o); // Add deleted entry to user-edtied list
                        }
                    }
                    else {
                        if (newSolutions.indexOf(solution.o) < 0) {
                            newSolutions.push(solution.o); // build new topic.temp value
                        }
                    }
                }
                // No changes detected...
                if (!changed) {
                    _this.notify.error('No change detected');
                    return;
                }
                // If dupes...
                if (dupes > 0) {
                    _this.notify.error('There are one or more duplicate Solution IDs in the list');
                    return;
                }
                _this.editableSolution = false;
                _this.editableDuplicate = false;
                _this.isSolutionUpdating = true;
                // If we get here, there's been a change... build string of the new values
                if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                    _this.updateUserUpdatedSolutions(line, newSolutions, userSolutions);
                    // Update the comments...
                    _this.topic.temp.comments.eligibility.push({
                        comment: line.row_id + " Solution ID(s) Updated - Details: " + comments + " - Justification: " + dResult.comments,
                        source: _this.env.user.email,
                        time: Date.now()
                    });
                    // Send for update
                    _this.topic.sendForUpdateGeneral([_this.comp, 'comments'], true);
                }
            }
        });
    };
    /**
     * Function if someone edits a Brand Family's Duplicate Opp No.
     * @param event
     * @param action
     * @param line
     */
    DetailBrandFamilyController.prototype.editDupeOpp = function (event, action, line) {
        var _this = this;
        var items = {
            oppyName: line.dup_check_num
        };
        this.Dialog.updateValidForm(event, items, 'detail-general-solution-update-don-dialog.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                // No changes detected...
                if (line.dup_check_num === dResult.oppyName.toUpperCase()) {
                    _this.notify.error('No change detected');
                    return;
                }
                // Log entry
                var comments = "Changed from '" + (line.dup_check_num ? line.dup_check_num : 'No Value') + "' to '" + dResult.oppyName.toUpperCase() + "'";
                _this.editableSolution = false;
                _this.editableDuplicate = false;
                _this.isDupeUpdating = true;
                // If we get here, there's been a change... build string of the new values
                if (_this.topic.updatePartialSocketStatus([_this.comp], 'Updating')) {
                    _this.updateUserUpdatedDupe(line, dResult.oppyName.toUpperCase());
                    // Update the comments...
                    _this.topic.temp.comments.eligibility.push({
                        comment: line.row_id + " Duplicate Opportunity No. Updated - Details: " + comments,
                        source: _this.env.user.email,
                        time: Date.now()
                    });
                    // Send for update
                    _this.topic.sendForUpdateGeneral([_this.comp, 'comments'], true);
                }
            }
        });
    };
    DetailBrandFamilyController.prototype.getOrigSols = function (line) {
        return 'The following Solution IDs have been either added, edited or deleted by users:\n' +
            line.solutionId_user + '\n\nSee the Comments log for full details of the changes';
    };
    /**
     * Function to update the new list of solutions for a line, as well as record history for original
     * solutions (from mysa) that have been changed and should therefore not be overwritten when gpp
     * data is refreshed on doc open or via Refresh GPP/MySA
     * @param line
     * @param newSolutions
     * @param userSolutions
     */
    DetailBrandFamilyController.prototype.updateUserUpdatedSolutions = function (line, newSolutions, userSolutions) {
        // Update solution ids for the line in question
        var originalSolutions = [];
        for (var _i = 0, _a = this.topic.temp.gpp; _i < _a.length; _i++) {
            var gpp = _a[_i];
            // Find the line updated...
            if (gpp.row_id === line.row_id) {
                // And update it
                gpp.solutionId = newSolutions.join('\n');
                // Update the list of solutions manipulated by users
                if (angular.isDefined(gpp.solutionId_user)) {
                    originalSolutions = gpp.solutionId_user.split('\n');
                }
                // Loop through list of solutions mucked about with...
                for (var _b = 0, userSolutions_1 = userSolutions; _b < userSolutions_1.length; _b++) {
                    var sol = userSolutions_1[_b];
                    // If not already listed...
                    if (originalSolutions.indexOf(sol) < 0) {
                        originalSolutions.push(sol); // Add
                    }
                }
                gpp.solutionId_user = originalSolutions.join('\n');
                break;
            }
        }
    };
    DetailBrandFamilyController.prototype.updateUserUpdatedDupe = function (line, newOpp) {
        for (var _i = 0, _a = this.topic.temp.gpp; _i < _a.length; _i++) {
            var gpp = _a[_i];
            // Find the line updated...
            if (gpp.row_id === line.row_id) {
                // And update it
                gpp.dup_check_num = newOpp;
                break;
            }
        }
    };
    DetailBrandFamilyController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    /**
     * @param index Function if someone changes the Elig Decision of a Brand Family line, or Duplicate Opp Flag
     */
    DetailBrandFamilyController.prototype.updateGppEligstatus = function (index) {
        if (!this.topic.editableComponents[this.comp].socket) {
            if (this.topic.temp[this.comp][index].elig_decision !== this.topic.topic[this.comp][index].elig_decision ||
                this.topic.temp[this.comp][index].dup_check_flg !== this.topic.topic[this.comp][index].dup_check_flg) {
                if (this.topic.temp[this.comp][index].elig_decision !== this.topic.topic[this.comp][index].elig_decision) {
                    switch (this.topic.temp[this.comp][index].elig_decision) {
                        case 'BP ID':
                        case 'Eligible':
                            this.topic.temp[this.comp][index].dup_check_flg = 'No';
                            break;
                        case 'Solution only':
                            if (this.topic.topic.solutionDecision === 'Solution and SSA') {
                                this.topic.temp[this.comp][index].dup_check_flg = 'Yes';
                            }
                            else if (this.topic.topic.solutionDecision === 'Solution only') {
                                this.topic.temp[this.comp][index].dup_check_flg = 'No';
                            }
                            break;
                        case 'Not Eligible':
                        case 'IBM ID':
                            this.topic.temp[this.comp][index].dup_check_flg = 'Yes';
                            break;
                        default:
                            break;
                    }
                }
                if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                    this.topic.sendForUpdateGeneral([this.comp, 'comments'], true);
                }
            }
        }
    };
    DetailBrandFamilyController.prototype.setEligOptions = function () {
        this.eligOptions = [];
        if (!this.topic.topic.goe || !this.topic.topic.goe.picked
            || !this.topic.topic.states || !this.topic.topic.states.bpoi) {
            // do nothing
            return;
        }
        else if ((!this.topic.is2ndGOENeeded() && this.topic.topic.states.bpoi.geYes)
            || (this.topic.is2ndGOENeeded() && this.topic.topic.states.bpoi.geNo)) {
            this.eligOptions = this.settings.bpoiEligibilityOptions;
        }
        else {
            this.eligOptions = this.settings.eligibilityOptions;
        }
        // If Solution Decision exists, then Solution only needs to be an option in the eligdecisions
        if (this.topic.topic.solutionDecision) {
            // Ensure soluton only is in the list
            if (this.eligOptions.indexOf('Solution only') === -1) {
                this.eligOptions.splice(0, 0, 'Solution only'); // Add it
            }
        }
        else {
            // Ensure soluton only is not in the list
            if (this.eligOptions.indexOf('Solution only') > -1) {
                this.eligOptions.splice(this.eligOptions.indexOf('Solution only'), 1); // Lose it
            }
        }
    };
    DetailBrandFamilyController.prototype.setDuplicateCheckOptions = function () {
        this.duplicateOptions = ['Yes', 'No'];
        return;
    };
    DetailBrandFamilyController.$inject = ['topic', 'settings', '$scope', 'env', 'Dialog', 'notify'];
    return DetailBrandFamilyController;
}());
var DetailBrandFamilyComponent = (function () {
    function DetailBrandFamilyComponent() {
        this.bindings = bfBind;
        this.templateUrl = 'detail-family-brand.html';
        this.controller = DetailBrandFamilyController;
    }
    return DetailBrandFamilyComponent;
}());
angular
    .module('application')
    .component('detailBrandFamily', new DetailBrandFamilyComponent());

//# sourceMappingURL=detail.general.bf.component.js.map
